import { Coins, Smile, Globe, ShieldCheck } from "lucide-react";
import { METERS } from "@/lib/engine";
import { useLang } from "@/context/LangContext";

const ICONS = { eco: Coins, hap: Smile, intl: Globe, stab: ShieldCheck };
const COLORS = { eco: "var(--m-eco)", hap: "var(--m-hap)", intl: "var(--m-intl)", stab: "var(--m-stab)" };

const dotSize = (p) => (p >= 15 ? 12 : p >= 10 ? 9 : 6);

const MeterIndicator = ({ k, preview, delta }) => {
  if (preview > 0) {
    const s = dotSize(preview);
    return <span className="pulse-dot rounded-full" style={{ width: s, height: s, background: COLORS[k] }} data-testid={`meter-${k}-preview`} />;
  }
  if (delta) {
    return <span className="flash-up text-xs font-bold font-display" style={{ color: delta > 0 ? "#4ade80" : "#f87171" }} data-testid={`meter-${k}-delta`}>{delta > 0 ? `+${delta}` : delta}</span>;
  }
  return null;
};

const MeterColumn = ({ k, value, preview, delta, label }) => {
  const Icon = ICONS[k];
  const danger = value <= 20 || value >= 80;
  return (
    <div className="flex flex-col items-center gap-1" data-testid={`meter-${k}`}>
      <div className="h-4 flex items-center justify-center">
        <MeterIndicator k={k} preview={preview} delta={delta} />
      </div>
      <div className={`relative w-full h-14 sm:h-16 rounded-2xl overflow-hidden border ${danger ? "border-[var(--gold)]" : "border-[var(--kg-red-border)]"} bg-black/40`}>
        <div className="meter-fill absolute bottom-0 left-0 right-0" style={{ height: `${value}%`, background: COLORS[k], opacity: 0.85 }} />
        <div className="absolute inset-0 flex items-center justify-center"><Icon size={22} className="drop-shadow" color="#fff" /></div>
      </div>
      <div className="text-[10px] sm:text-xs font-semibold uppercase tracking-wider text-[var(--text-light)]/80 truncate w-full text-center">{label}</div>
      <div className="text-xs font-display font-bold" style={{ color: COLORS[k] }} data-testid={`meter-${k}-value`}>{value}</div>
    </div>
  );
};

export const Meters = ({ meters, preview, deltas }) => {
  const { t } = useLang();
  return (
    <div className="grid grid-cols-4 gap-2 w-full" data-testid="meters-bar">
      {METERS.map((k) => (
        <MeterColumn key={k} k={k} value={meters[k]} preview={Math.abs(preview?.[k] || 0)} delta={deltas?.[k] || 0} label={t.meters[k]} />
      ))}
    </div>
  );
};
